import React from 'react';
import TextBoxInput from 'components/Inputs/TextBoxInput/TextBoxInput';
import useValidator from 'hooks/useValidator';
import Input from 'components/Inputs/Input/Input';
import Button from 'components/Button/Button';

type FormProps = {
  type: string;
  onSubmitReferral: (payload: Record<string, string>) => void;
};

function SpecialtyReferralForm({ type, onSubmitReferral }: FormProps) {
  const [validator, showValidationMessage] = useValidator({});
  const [payload, setPayload] = React.useState({
    specialtyType: '',
    reasonForReferral: '',
    icdCode: '',
    referralNotes: '',
  });

  const handleSubmit = async () => {
    if (!validator.allValid()) {
      showValidationMessage(true);
      return;
    }

    onSubmitReferral({
      type,
      specialtyType: payload.specialtyType,
      reason: payload.reasonForReferral,
      icdCode: payload.icdCode,
      notes: payload.referralNotes,
    });
  };

  return (
    <div className="space-y-5 -mt-2">
      <div>
        <h3 className="text-sm leading-8 mb-2">Specialty Type</h3>
        <Input
          className="peer-[.validator-error]/specialtyType:!border-river-red peer-[.validator-error]/specialtyType:!mb-5 
          peer-[.validator-error]/specialtyType:focus:!ring-river-red"
          name="specialtyType"
          value={payload.specialtyType}
          placeholder="Eg. Dermatology"
          onChange={event =>
            setPayload(fndPayload => ({ ...fndPayload, specialtyType: event.target.value }))
          }
          validator={validator.message(
            'specialtyType',
            payload.specialtyType,
            'required|string|min:2',
            {
              messages: {
                required: 'Please enter specialty type.',
              },
              className: 'peer/specialtyType validator-error mt-1 top-[46px] ml-1',
            },
          )}
        />
      </div>

      <div>
        <h3 className="text-sm leading-8 mb-2">Reason for Referral or Diagnosis</h3>
        <Input
          className="peer-[.validator-error]/reasonForReferral:!border-river-red peer-[.validator-error]/reasonForReferral:!mb-5 
          peer-[.validator-error]/reasonForReferral:focus:!ring-river-red"
          name="reasonForReferral"
          value={payload.reasonForReferral}
          placeholder=""
          onChange={event =>
            setPayload(fndPayload => ({ ...fndPayload, reasonForReferral: event.target.value }))
          }
          validator={validator.message(
            'reasonForReferral',
            payload.reasonForReferral,
            'required|string|min:2',
            {
              messages: {
                required: 'Provide reason for the referral or diagnosis.',
              },
              className: 'peer/reasonForReferral validator-error mt-1 top-[46px] ml-1',
            },
          )}
        />
      </div>

      <div>
        <h3 className="text-sm leading-8 mb-2">ICD-10 Code</h3>
        <Input
          className="peer-[.validator-error]/icdCode:!border-river-red peer-[.validator-error]/icdCode:!mb-5 
          peer-[.validator-error]/icdCode:focus:!ring-river-red"
          name="icdCode"
          value={payload.icdCode}
          placeholder="A00-000"
          onChange={event =>
            setPayload(fndPayload => ({ ...fndPayload, icdCode: event.target.value }))
          }
          validator={validator.message('icdCode', payload.icdCode, 'required|string', {
            messages: {
              required: 'Provide the ICD-10 Code.',
            },
            className: 'peer/icdCode validator-error mt-1 top-[46px] ml-1',
          })}
        />
      </div>

      <div>
        <h3 className="text-sm leading-8 mb-2">Add your referral notes or comments here:</h3>
        <TextBoxInput
          name="referralNotes"
          placeholder="Type your response here..."
          value={payload.referralNotes}
          onChange={event =>
            setPayload(fndPayload => ({ ...fndPayload, referralNotes: event.target.value }))
          }
          rows={5}
          className="peer-[.validator-error]/referralNotes:!border-river-red peer-[.validator-error]/referralNotes:!mb-5 
          peer-[.validator-error]/referralNotes:focus:!ring-river-red"
          validator={validator.message(
            'referralNotes',
            payload.referralNotes,
            'required|string|min:2',
            {
              messages: {
                required: 'Please add a referral notes or comments.',
              },
              className: 'peer/referralNotes validator-error mt-3 top-[150px] ml-1',
            },
          )}
        />
      </div>

      <div className="!mt-14 text-center">
        <Button label="Submit" onClick={() => handleSubmit()} className="!px-2 !min-w-[250px]" />
      </div>
    </div>
  );
}

export default SpecialtyReferralForm;
